﻿window.mglep_tariffzone = function () {

    var instance = {
        
        widgetDidMount: function (state) {
            var staticName = "saldo_tariffzone_tableidhour_";
            const root = document.getElementById(state.root);
            const valuesRadio = root.querySelectorAll('input[type="radio"]');
            for (var i = 0; i < valuesRadio.length; i++) {
                const el = valuesRadio[i];
                    el.addEventListener('change', function (e) {
                        const t = e.currentTarget;
                        var spl = t.name.split(/_/);
                        setState(spl[1], t);
                });
            }

            const valuesInput = root.querySelectorAll('input[type="text"]');
            for (var j = 0; j < valuesInput.length; j++) {
                const el = valuesInput[j];
                el.addEventListener('focusout', function (e) {
                    const t = e.currentTarget;
                    var spl = t.name.split(/_/);
                    var valmin = t.getAttribute("min");
                    var valmax = t.getAttribute("max");
                    var label = document.getElementById(staticName + "commcbgroup_" + spl[1]);
                    if (t.value < valmin || t.value > valmax) {
                        label.innerText = "Значение не может быть меньше, чем 1 и больше 3!";
                        setNoValidState(spl[1], t);
                        return;
                    }
                    else {
                        label.innerText = "";
                    }
                    
                    var radio = document.getElementById(staticName + "radio" + t.value + spl[1]);
                    radio.setAttribute("checked", "true");
                    setState(spl[1], t);
                });
                el.addEventListener('keyup', function (e) {
                    if (event.keyCode === 13) {
                        console.log("keyup == 13");
                        const t = e.currentTarget;
                        var spl = t.name.split(/_/);
                        var txt = document.getElementById(staticName + "cbgroup_" + (Number(spl[1]) + 1));
                        if (txt != null) {
                            txt.focus();
                            txt.select();
                        }

                    }
                });
            }

            function setNoValidState(spl, t) {
                var div = document.getElementById(staticName + "divcolor" + spl);
                div.setAttribute("class", "ticolor ticolor-red");
                div.setAttribute("title", "Данные некорректны");
                for (i = 0; i < 4; i++) {
                    var radio = document.getElementById(staticName + "radio" + i + spl);
                    radio.setAttribute("checked", "false");
                }

                var h1 = document.getElementsByName("hiddenval" + spl);
                var h2 = document.getElementsByName("hiddenoldval" + spl);
                h1[0].value = t.value;
                h2[0].value = t.value;
                //document.getElementById(staticName + "span" + spl).innerText = t.value;
            }


            function setState(spl, t) {
                var h1 = document.getElementsByName("hiddenval" + spl);
                var h2 = document.getElementsByName("hiddenoldval" + spl);
                h1[0].setAttribute('value', t.value);
                //document.getElementById(staticName + "span" + spl).innerText = t.value;
                var div = document.getElementById(staticName + "divcolor" + spl);
                var txt = document.getElementById(staticName + "cbgroup_" + spl);
                //txt.setAttribute("value", t.value);
                txt.value = t.value;
                if (h1[0].value != h2[0].value) {
                    if (h1[0].value != 0) {
                        div.setAttribute("class", "ticolor ticolor-greenwhite");
                        div.setAttribute("title", "Норма. Замещены ручным вводом");
                    }
                    else {
                        div.setAttribute("class", "ticolor ticolor-blackwhite");
                        div.setAttribute("title", "Нет данных. Замещены ручным вводом");
                    }
                }
                else {

                    if (h2[0].value == 0) {
                        div.setAttribute("class", "ticolor ticolor-black");
                        div.setAttribute("title", "Нет данных");
                    }
                    else {

                        div.setAttribute("class", "ticolor ticolor-green");
                        div.setAttribute("title", "Норма");
                    }
                }
            }
        }


    };
    return instance;
}();

